import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useId } from "@floating-ui/react";
import { COLUMN_POSITION_STARTS, COLUMN_POSITION_ENDS } from "./types";
import { Typography } from "./Typography";
import { useContext, useEffect, useState } from "react";
import { FOCUS_VISIBLE_OUTLINE } from "../utils/css-helpers";
import { ThemeProviderContext } from "./ThemeProvider";
export const Switch = ({ size = "medium", label, hideLabel = false, isOn = false, isDisabled = false, name, labelPosition = "left", onChange, fitting = "content-fit", leftColumnStart = 4, leftColumnEnd = 6, rightColumnStart = 7, rightColumnEnd = 13, className = "", testId, }) => {
    const theme = useContext(ThemeProviderContext);
    const inputId = useId();
    const handleChange = (event) => {
        setInternalIsOn(event.target.checked);
        onChange === null || onChange === void 0 ? void 0 : onChange({ event, value: event.target.checked });
    };
    const [internalIsOn, setInternalIsOn] = useState(isOn);
    useEffect(() => {
        setInternalIsOn(isOn);
    }, [isOn]);
    const inputClasses = [
        "appearance-none",
        "rounded-full",
        "cursor-pointer",
        internalIsOn && !isDisabled
            ? "bg-cta-primary-default dark:bg-general-indigo-primary-darkmode"
            : "bg-general-neutral-secondary dark:bg-general-neutral-secondary-darkmode",
        size === "medium" && ["w-3.5", "h-2"],
        size === "large" && ["w-4.5", "h-2.5"],
        "focus:outline-transparent",
        FOCUS_VISIBLE_OUTLINE,
    ];
    const thumbClassNames = [
        "absolute",
        "bg-general-light-primary dark:bg-general-dark-primary-darkmode",
        "rounded-full",
        "cursor-pointer",
        "border",
        size === "medium" && ["w-[14px]", "h-[14px]"],
        size === "large" && ["w-[18px]", "h-[18px]"],
        internalIsOn && "translate-x-full",
        internalIsOn &&
            !isDisabled &&
            "border-cta-primary-default dark:border-border-brand-darkmode",
        internalIsOn &&
            isDisabled &&
            "border-general-neutral-secondary dark:border-general-neutral-secondary-darkmode",
        !internalIsOn &&
            isDisabled &&
            "border-border-subdued dark:border-border-subdued-darkmode",
        !internalIsOn &&
            !isDisabled &&
            "border-border-regular dark:border-border-regular-darkmode",
        "duration-100 ease-linear",
        "pointer-events-none",
    ];
    const fontVariant = size === "medium" ? "body-medium" : "body-large";
    const renderLabel = () => {
        if (hideLabel) {
            return null;
        }
        return (_jsx("label", { className: classNames(fitting === "layout-fit" && [
                COLUMN_POSITION_STARTS[labelPosition === "right" ? rightColumnStart : leftColumnStart],
                COLUMN_POSITION_ENDS[labelPosition === "right" ? rightColumnEnd : leftColumnEnd],
            ]), htmlFor: inputId, [theme.testAttribute]: testId, children: _jsx(Typography, { variant: fontVariant, color: isDisabled ? "text-disabled" : "text-primary", className: classNames(labelPosition === "right" ? "ml-1" : "mr-1"), children: label }) }));
    };
    return (_jsxs("div", { style: { overflowWrap: "anywhere" }, className: classNames([
            "flex",
            "cursor-pointer",
            "min-w-[112px]",
            fitting === "layout-fit" && ["!w-full", "grid grid-cols-12"],
            className,
        ]), children: [labelPosition === "left" && renderLabel(), _jsxs("div", { className: classNames("flex", "relative", "items-center", fitting === "layout-fit" && [
                    COLUMN_POSITION_STARTS[labelPosition === "right" ? leftColumnStart : rightColumnStart],
                    COLUMN_POSITION_ENDS[labelPosition === "right" ? leftColumnEnd : rightColumnEnd],
                ]), children: [_jsx("input", { type: "checkbox", role: "switch", checked: internalIsOn, name: name, onChange: handleChange, className: classNames(inputClasses), "aria-label": hideLabel ? label : "", disabled: isDisabled, id: inputId }), _jsx("span", { className: classNames(thumbClassNames) })] }), labelPosition === "right" && renderLabel()] }));
};
//# sourceMappingURL=Switch.js.map